import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import PetsIcon from '@mui/icons-material/Pets';
import { Link as RouterLink } from "react-router-dom";
//TODO: fix react router
const pages = [
  {
    displayText: 'Home',
    path: '/'
  },
  {
    displayText: 'Calculator',
    path: '/calculator'
  },
  {
    displayText: 'About',
    path: '/about'
  },
] 

function NavBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="sticky" sx={{backgroundColor: "#cce8db"}}> {/* #c1d4e3 */}
      <Container maxWidth="xl">
        <Toolbar disableGutters >
          {/* small screen nav hamburger menu */}
          <PetsIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, color: '#363430' }} />
          <Typography
            variant="h6"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: '#363430',
              textDecoration: 'none',
            }}
          >
            PupCals
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="navbar button"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page, index) => (
                <MenuItem key={index} onClick={handleCloseNavMenu}>
                  <Typography sx={{  color: '#363430', display: 'block' }} component={RouterLink} to={page.path} textAlign="center">{page.displayText}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* Large view */}
          <PetsIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1, color: '#363430' }} />
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: '#363430',
              textDecoration: 'none',
            }}
          >
            PupCals
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page, index) => (
              <Button
                key={index}
                href={page.path}
                sx={{ my: 2, color: '#363430', display: 'block' }}
              >
                {page.displayText}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;
